import * as actions from "../action.constants";

const initialState = {
  createTemplateData: {},
  createNonTestData: {},
  createTestData: {},
  testTemplateList: [],
  isTestFormVisible: false,
  isNonTestFormVisible: false,
  templateControllerList: [],
  testSensorsList: [],
  nonTestTemplateList: [],
  templateListData: {},
  selectedControllerList: [],
  reportSites: [],
  reportLocations: [],
  reportControllers: [],
  reportFormData: {},
  reportsData: {},
  isLoading: false,
  templateData: {},
  templateLabelValue: [],
  inventoryLabelValue: [],
};

const storeCreateTemplateData = (state, action) => {
  return {...state, createTemplateData: action.payload};
};

const storeCreateNonTestData = (state, action) => {
  return {...state, createNonTestData: action.payload};
};

const storeCreateTestData = (state, action) => {
  return {...state, createTestData: action.payload};
};

const storeTestTemplateList = (state, action) => {
  return {...state, testTemplateList: action.payload || []};
};

const nonTestFormVisible = (state, action) => {
  return {...state, isNonTestFormVisible: action.payload};
};

const testFormVisible = (state, action) => {
  return {...state, isTestFormVisible: action.payload};
};

const storeTemplateController = (state, action) => {
  return {...state, templateControllerList: action.payload || []};
};

const storeTestSensors = (state, action) => {
  return {...state, testSensorsList: action.payload || []};
};

const storeNonTestTemplate = (state, action) => {
  return {...state, nonTestTemplateList: action.payload || []};
};

const storeTemplate = (state, action) => {
  return {...state, templateListData: action.payload || {}};
};

const storeReportSites = (state, action) => {
  return {...state, reportSites: action.payload || []};
};

const storeReportLocations = (state, action) => {
  return {...state, reportLocations: action.payload || []};
};

const storeReportControllers = (state, action) => {
  return {...state, reportControllers: action.payload || []};
};

const storeReportSelectedControllerList = (state, action) => {
  return {...state, selectedControllerList: action.payload};
};

const storeCreateReportData = (state, action) => {
  return {...state, reportFormData: action.payload || {}};
};

const storeReportsList = (state, action) => {
  return {...state, reportsData: action.payload};
};

const handlers = {
  [actions.STORE_CREATE_TEMPLATE_DATA]: storeCreateTemplateData,
  [actions.STORE_CREATE_NON_TEST_DATA]: storeCreateNonTestData,
  [actions.STORE_CREATE_TEST_DATA]: storeCreateTestData,
  [actions.STORE_TEST_TEMPLATE_LIST]: storeTestTemplateList,
  [actions.STORE_TEMPLATE_CONTROLLERS]: storeTemplateController,
  [actions.STORE_TEST_SENSORS]: storeTestSensors,
  [actions.STORE_NON_TEST_TEMPLATE]: storeNonTestTemplate,
  [actions.STORE_TEMPLATES]: storeTemplate,
  [actions.TEST_FORM_VISIBLE]: testFormVisible,
  [actions.NON_TEST_FORM_VISIBLE]: nonTestFormVisible,
  [actions.STORE_REPORTS_SITES]: storeReportSites,
  [actions.STORE_REPORTS_LOCATIONS]: storeReportLocations,
  [actions.STORE_REPORT_CONTROLLERS]: storeReportControllers,
  [actions.STORE_CREATE_REPORT_DATA]: storeCreateReportData,
  [actions.STORE_REPORT_SELECTED_CONTROLLERS_LIST]: storeReportSelectedControllerList,
  [actions.STORE_REPORTS]: storeReportsList,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
